import { Calendar as CalendarIcon } from "lucide-react";
import { DateRange } from "react-day-picker";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Dispatch, SetStateAction } from "react";
import { formatDateLocale } from "@/utils/helpers";
import { useIntl } from "react-intl";

interface Props {
  filterText: string;
  className?: string;
  dateRange: DateRange | undefined;
  setDateRange: Dispatch<SetStateAction<DateRange | undefined>>;
  align?: "start" | "end" | "center";
  startMonth?: Date;
  endMonth?: Date;
};

export function DatePickerWithRange({ className, dateRange, setDateRange, filterText, align = "start", startMonth, endMonth }: Props) {

  // Hooks
  const intl = useIntl();

  return (
    <div className={cn("grid gap-2 relative", className)}>
      <Popover data-cy="date-range-picker">
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant={"outline"}
            className={cn(
              "flex-1 w-full justify-center text-center font-normal dark:text-white",
              !dateRange && "text-muted-foreground"
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4 dark:text-white shrink-0" />
            {dateRange?.from ? (
              dateRange.to ? (
                <>
                  {formatDateLocale(intl, dateRange.from)} -{" "}
                  {formatDateLocale(intl, dateRange.to)}
                </>
              ) : (
                formatDateLocale(intl, dateRange.from)
              )
            ) : (
              <span className="dark:text-white">{filterText}</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="absolute w-auto p-2 dark:bg-mfdarklighter" align={align} >
          <Calendar
            mode="range"
            defaultMonth={dateRange?.from}
            selected={dateRange}
            onSelect={setDateRange}
            numberOfMonths={2}
            startMonth={startMonth}
            endMonth={endMonth}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
